(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('transactionsArchingController', transactionsArchingController);

    transactionsArchingController.$inject = ['$stateParams', 'datePickerService', '$translate', 'currencies',
        'regions', 'tabs', 'typeTransaction', 'branchOfficeService', 'linkService', 'dateService', 'balanceUserService',
        'printService','transactionsService','userService','userSession', 'excelService'];

    function transactionsArchingController($stateParams, datePickerService, $translate, currencies, regions, tabs,
                                           typeTransaction, branchOfficeService, linkService, dateService, balanceUserService,
                                           printService,transactionsService,userService,userSession, excelService){
        var vm = this;
        vm.currencies = currencies;
        vm.userSession = userSession.data;
        vm.filterPassages = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            detail: true,
            fromDate: null
        };

        vm.regions = (regions.data._embedded) ? regions.data._embedded.regions : [];
        vm.users = [];
        vm.typeTransaction = typeTransaction;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterPassages.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterPassages.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.isReport = false;
        vm.isDownload = false;
        vm.reportBalanceHtml = '';
        vm.toDate = null;
        vm.type = '';
        vm.reportTransactionPassengerHtml = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.onChangeRegion = function() {
            var region = vm.filterPassages.region;
            if (region !== null && region !== undefined) {
                vm.users = [];
                userService.getUsersByRegion(linkService.getLinkId(region._links.self.href))
                    .then(function (response) {
                        vm.users = (response.data) ? response.data : [];
                        // vm.users = getUsers(res,vm.userSession);
                    });
            } else {
                vm.disabledUserBranch = false;
                vm.users = [];
            }

        }

        vm.cancelSalesBook = function (formGenerateSalesBook) {
            vm.filterSalesBook.taxpayer = null;
            vm.filterSalesBook.economicActivity = null;
            vm.filterSalesBook.management = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateTransactionsArching = function (isValid, formGenerateArching) {
            if(isValid){
                var auxFromDate = vm.filterPassages.fromDate;
                vm.transactionLuggage = {};
                vm.toDate = null;
                vm.type = 'type=PASSAGE&type=CARGO&type=LUGGAGE&type=SSR';
                vm.transactionLuggage.fromDate = dateService.dateTimeString(auxFromDate, 1);
                vm.transactionLuggage.currency = vm.filterPassages.currency.code;
                vm.transactionLuggage.detail = vm.filterPassages.detail;
                vm.transactionLuggage.region = linkService.getLinkId(vm.filterPassages.region._links.self.href);
                vm.transactionLuggage.employee = vm.filterPassages.user.login;

                balanceUserService.getReportBalanceUserByUser(vm.transactionLuggage.employee, vm.type, vm.transactionLuggage.fromDate, vm.transactionLuggage.detail).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateTrafficPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_detail' : 'report_total');
        }

        vm.cancelTransactionsArching = function(formGenerateArching) {
            vm.filterPassages.currency = null;
            vm.filterPassages.toDate = 1;
            vm.filterPassages.detail = true;
            vm.reportBalanceHtml = '';
            vm.toDate = null;
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };
    }
})();
